import { Injectable } from '@angular/core';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './matter-uploaded-files.actions';

@Injectable({
	providedIn: 'root',
})
export class MatterUploadedFilesDispatch {
	@Dispatch()
	Delete = (fileId: string): actions.Delete => new actions.Delete(fileId);

	@Dispatch()
	UpdateFileName = (docId: string, name: string): actions.UpdateFileName =>
		new actions.UpdateFileName({ docId, name });

	@Dispatch()
	UpdateFileSystemTags = (
		docId: string,
		tags: string[],
	): actions.UpdateFileSystemTags =>
		new actions.UpdateFileSystemTags({ docId, tags });
}
